export const GET_PARTNER_STATUS_LIST = "GET_PARTNER_STATUS_LIST";

export const GET_BUSINESS_TYPE_LIST = "GET_BUSINESS_TYPE_LIST";

export const PARTNER_VIEW_ACTION = "PARTNER_VIEW_ACTION";

export const GET_PARTNER_GUBUNS_ACTION = "GET_PARTNER_GUBUNS_ACTION";
